//import { Plants } from "../@types/plants";
import api from "./api";


export const createPlantComposite = async (body: any) => {
    const response = await api.post(`plants/createComplete`, body);
    return response.data;
};

export const getplantsAll = async (url?: string) => {
    if(url){
        const response = await api.get(`plants/listAll/${url}`);
        return response.data;
    }else{
        const response = await api.get(`plants/listAll`);
        return response.data;
    }
};

export const getPlantsAllSimple = async (url?: string) => {
    if(url){
        const response = await api.get(`plants/listAllSimple/${url}`);
        return response.data;
    }else{
        const response = await api.get(`plants/listAllSimple`);
        return response.data;
    }
};

export const getplantsAllPagination = async (url?: string) => {
    if(url){
        const response = await api.get(`plants/listAllPagination/${url}`);
        return response.data;
    }else{
        const response = await api.get(`plants/listAllPagination`);
        return response.data;
    }
};

export const getplantsAllSimplePagination = async (url?: string) => {
    if(url){
        const response = await api.get(`plants/listAllPaginationSimple/${url}`);
        return response.data;
    }else{
        const response = await api.get(`plants/listAllPaginationSimple`);
        return response.data;
    }
};

export const getplantsOne = async (id: string) => {
    const response = await api.get(`plants/listOneV2/${id}`);
    return response.data;
};

export const getClimaPlantOne = async (id: string) => {
    const response = await api.get(`plants/datesClimaPlant/${id}`);
    return response.data;
};

export const getPlantsImported = async (idCredential: string) => {
    const response = await api.get(`plants/listPlantsForImported/${idCredential}`);
    return response.data;
};

export const getPlanUsage = async (idUnitBranch: string) => {
    const response = await api.get(`plants/planUsage/${idUnitBranch}`);
    return response.data;
};

export const postLogin = async (body: any) => {
    const response = await api.post(`integrationAPI/`, body);
    return response.data.result;
};

export const importedPlants = async (body: any) => {
    const response = await api.post(`plants/importedPlants/`, body);
    return response.data;
};

export const importedPlantsRabbitMq = async (body: any) => {
    const response = await api.post(`plants/importedPlantsRabbitMQ/`, body);
    return response.data;
};

export const putPlantOne = async (id: string, body: any) => {
    const response = await api.put(`plants/${id}`, body);
    return response.data.result;
};

export const putPlantOneComposite = async (id: string, body: any) => {
    const response = await api.put(`plants/updateVinculoPlantComposite/${id}`, body);
    return response.data.result;
};

export const putPlantOneUnlinkComposite = async (id: string, body: any) => {
    const response = await api.put(`plants/updateDesvinculoPlantComposite/${id}`, body);
    return response.data.result;
};

export const putPrognosisOne = async (id: string, body: any) => {
    const response = await api.put(`prognosis/${id}`, body);
    return response.data.result;
};

export const deletePlantOne = async (id: string) => {
    const response = await api.delete(`plants/${id}`);
    return response.data.result;
};


export const postPrognosisOne = async (body: any) => {
    const response = await api.post(`prognosis/`, body);
    return response.data.result;
};

export const postImportedChartsPortalOne = async (body: any) => {
    const response = await api.post(`updateLoginsPlantAPIGraficosRabbitMQ/`, body);
    return response.data.result;
};

export const getImportedChartsPlantPortalOne = async (data: any) => {
    const response = await api.get(`plants/updateLoginsPlantOneGraficos/?idCredential=${data.idCredential ? data.idCredential : ""}&idPlant=${data.idPlant ? data.idPlant : ""}&data_imported=${data.data_imported ? data.data_imported : ""}`);
    return response.data;
};

export const getExpansionPortfolio = async (params?: Record<string, any>) => {
    const response = await api.get(`plants/expansion-portfolio`, { params });
    return response.data;
};

export const getPlantExpansionCharts = async (id: string, months?: number) => {
    const response = await api.get(`plants/listOneCharts/${id}`, {
        params: months ? { months } : undefined,
    });
    return response.data;
};